"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextContainer = exports.ItemTextWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const TextContainer = exports.TextContainer = _styledComponents.default.div.withConfig({
  displayName: "SubMenuItemstyles__TextContainer",
  componentId: "sc-1be2o4a-0"
})(["display:flex;align-items:center;justify-content:space-between;"]);
const ItemTextWrapper = exports.ItemTextWrapper = _styledComponents.default.div.withConfig({
  displayName: "SubMenuItemstyles__ItemTextWrapper",
  componentId: "sc-1be2o4a-1"
})(["width:", ";padding-right:16px;"], _ref => {
  let {
    customItemWidth
  } = _ref;
  return customItemWidth ? '206px' : '100%';
});